/**
 * JaiRichText
 *
 * The one renderer for JAI-generated prose (Claude's streamed markdown-lite
 * output: **bold**, `- ` bullets, blank-line paragraph breaks). Replaces five
 * near-identical hand-rolled parsers that had each drifted to a different
 * font size / weight / spacing, which is why the same kind of AI answer used
 * to look inconsistent from page to page.
 *
 * Callers that need to react to structured markers (## Team Fit:, **Risk:**,
 * [ACTION:x]) must extract those themselves before passing the remaining
 * prose in here — this component only renders text, bold and bullets.
 *
 * Parsing/rendering helpers live in richText.jsx so this file can stay a
 * component-only export (required for Fast Refresh) and StreamingRichText
 * can reuse the exact same helpers for a live-typing reply.
 */

import { V2 } from './JaiV2'
import { stripMarkers, toBlocks, renderBlocks } from './richText'

export default function JaiRichText({ content, dark = false, style }) {
  const clean = stripMarkers(content)
  if (!clean) return null

  const color = dark ? '#FFFFFF' : V2.navy
  const dotColor = dark ? 'rgba(255,255,255,0.55)' : V2.navy
  const blocks = toBlocks(clean)

  return (
    <div style={{ fontSize: 15, lineHeight: 1.65, fontWeight: 400, color, ...style }}>
      {renderBlocks(blocks, { color, dotColor })}
    </div>
  )
}
